// Dev-only visual feedback toolbar (agentation): click elements, add notes, copy them as
// markdown for an AI agent. It is a React component, so it gets its own small React root in a
// separate <div> next to the Nuxt app. The imports are dynamic and behind `import.meta.dev`, so
// neither React nor the toolbar ever reach a production bundle.
export default defineNuxtPlugin(() => {
  if (!import.meta.dev) return

  void (async () => {
    const [{ createElement }, { createRoot }, { Agentation }] = await Promise.all([
      import("react"),
      import("react-dom/client"),
      import("agentation"),
    ])
    const host = document.createElement("div")
    host.id = "agentation-root"
    document.body.appendChild(host)
    createRoot(host).render(createElement(Agentation))
  })().catch((error) => console.warn("[agentation] failed to start", error))
})
